"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.recentTradesSelector = exports.futuresRecentTradesSelector = void 0;
var _reselect = require("reselect");
var _numberFormatter = require("../../helpers/numberFormatter");
var _instrumentPositionSelectors = require("./instrumentPositionSelectors");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var recentTradesSelector = exports.recentTradesSelector = (0, _reselect.createSelector)([function (state) {
  return state.recentTrades;
}, _instrumentPositionSelectors.instrumentsWithProductFullNamesAndProductSymbols, function (state) {
  return state.apexCore.instrument.selectedInstrumentId;
}], function (recentTrades, instruments, selectedInstrumentId) {
  var tradesByInstrument = recentTrades[selectedInstrumentId];
  var instrument = instruments.find(function (item) {
    return item.InstrumentId === selectedInstrumentId;
  });
  if (!instrument || !tradesByInstrument) {
    return [];
  }
  var Product1Symbol = instrument.Product1Symbol,
    Product2Symbol = instrument.Product2Symbol;
  return tradesByInstrument.map(function (trade) {
    var quantity = (0, _numberFormatter.currency)(trade.Quantity, Product1Symbol);
    var price = (0, _numberFormatter.currency)(trade.Price, Product2Symbol);
    return _objectSpread(_objectSpread({}, trade), {}, {
      Quantity: quantity,
      Price: price
    });
  });
});
var futuresRecentTradesSelector = exports.futuresRecentTradesSelector = (0, _reselect.createSelector)([function (state) {
  return state.futures.recentTrades;
}, _instrumentPositionSelectors.instrumentsWithProductFullNamesAndProductSymbols, function (state) {
  return state.futures.instruments.selectedInstrumentId;
}], function (recentTrades, instruments, selectedInstrumentId) {
  var tradesByInstrument = recentTrades[selectedInstrumentId];
  var instrument = instruments.find(function (item) {
    return item.InstrumentId === selectedInstrumentId;
  });
  if (!instrument || !tradesByInstrument) {
    return [];
  }
  var Product1Symbol = instrument.Product1Symbol,
    Product2Symbol = instrument.Product2Symbol;
  return tradesByInstrument.map(function (trade) {
    var quantity = (0, _numberFormatter.currency)(trade.Quantity, Product1Symbol);
    var price = (0, _numberFormatter.currency)(trade.Price, Product2Symbol);
    return _objectSpread(_objectSpread({}, trade), {}, {
      Quantity: quantity,
      Price: price
    });
  });
});